import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

export function MobileBottomNav({ tabs }) {
  const location = useLocation();

  const isActive = (path, exact) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#0E0E23]/95 backdrop-blur-2xl border-t border-white/10 safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around px-1 pt-2 pb-3">
        {tabs.map((tab) => {
          const active = isActive(tab.path, tab.exact);
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className="flex flex-col items-center gap-0.5 min-w-0 flex-1 relative"
              data-testid={`mobile-nav-${tab.id}`}
            >
              {active && (
                <motion.div
                  layoutId="mobile-tab-indicator"
                  className="absolute -top-2 w-8 h-0.5 rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#3B82F6]"
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <tab.icon
                size={20}
                strokeWidth={active ? 2.2 : 1.5}
                className={active ? 'text-[#A78BFA]' : 'text-[#64748B]'}
              />
              {tab.badge > 0 && (
                <span
                  className={
                    tab.badgePulse
                      ? "absolute -top-1 right-[calc(50%-22px)] min-w-[16px] h-[16px] px-1 rounded-full bg-yellow-400 text-[#0E0E23] text-[9px] font-bold flex items-center justify-center shadow-[0_0_10px_rgba(252,211,77,0.7)] border border-yellow-200 animate-pulse"
                      : "absolute -top-1 right-[calc(50%-22px)] min-w-[16px] h-[16px] px-1 rounded-full bg-gradient-to-r from-[#EC4899] to-[#8B5CF6] text-white text-[9px] font-bold flex items-center justify-center shadow-[0_0_8px_rgba(236,72,153,0.5)]"
                  }
                  data-testid={`mobile-nav-${tab.id}-badge`}
                >
                  {tab.badge > 99 ? '99+' : tab.badge}
                </span>
              )}
              <span className={`text-[10px] font-medium truncate ${active ? 'text-[#A78BFA]' : 'text-[#64748B]'}`}>
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export function MobileHeader({ title, subtitle, rightAction }) {
  return (
    <div className="flex items-center justify-between mb-5 lg:hidden" data-testid="mobile-header">
      <div className="min-w-0 flex-1">
        <h1 className="text-lg font-bold text-white font-syne truncate">{title}</h1>
        {subtitle && <p className="text-xs text-[#9CA3AF] truncate">{subtitle}</p>}
      </div>
      {rightAction && <div className="flex-shrink-0 ml-3">{rightAction}</div>}
    </div>
  );
}

export function DesktopOnlyGate({ feature, children }) {
  return (
    <>
      {/* Desktop: show children */}
      <div className="hidden lg:block">{children}</div>
      {/* Mobile: show message */}
      <div className="lg:hidden flex flex-col items-center justify-center py-16 px-6 text-center" data-testid="desktop-only-gate">
        <div className="w-16 h-16 rounded-2xl bg-[#8B5CF6]/20 flex items-center justify-center mb-4">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#A78BFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
        </div>
        <p className="text-white font-bold font-syne text-base mb-1">Desktop Required</p>
        <p className="text-[#9CA3AF] text-sm max-w-xs">
          The {feature} works best on a larger screen. Open this page on your computer for the full experience.
        </p>
      </div>
    </>
  );
}
